// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import entityReducer from 'syft-acp-core/reducers/generators/entityReducer'
import * as entityTypes from 'syft-acp-core/reducers/generators/entities'

import * as types from './action-types'

export default entityReducer(
  'workerTier',
  {
    [entityTypes.ENTITY_FETCH_BEGIN]: types.WORKER_TIER_FETCH_BEGIN,
    [entityTypes.ENTITY_FETCH_SUCCEEDED]: types.WORKER_TIER_FETCH_SUCCEEDED,
    [entityTypes.ENTITY_FETCH_FAILED]: types.WORKER_TIER_FETCH_FAILED,
  },
  {
    idKey: 'worker_id',
    localEntityMap: true,
  },
)
